import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import EventFeedCard from '../components/EventFeedCard'
import LoadingSpinner from '../components/UI/LoadingSpinner'
import GradientButton from '../components/UI/GradientButton'
import { useFriendsEvents } from '../hooks/useFriendsEvents'

const FriendsEventFeed = () => {
    const navigate = useNavigate()
    const { user } = useAuth()
    const { events, loading, error } = useFriendsEvents()

    const handleEventClick = (eventId) => {
        navigate(`/event/${eventId}`)
    }

    return (
        <div className="p-8 max-w-4xl mx-auto">
            <div className="mb-8">
                <h1 className="text-4xl font-bold text-white mb-2">Friends Events</h1>
                <p className="text-gray-300">See what events your friends have been to</p>
            </div>

            {/* Loading State */}
            {loading && (
                <div className="text-center py-12">
                    <LoadingSpinner text="Loading friends events..." />
                </div>
            )}

            {/* Error State */}
            {error && !loading && (
                <div className="bg-red-500/20 border border-red-500/50 text-red-200 px-4 py-3 rounded-xl text-sm mb-4">
                    {error}
                </div>
            )}

            {/* Events Feed */}
            {!loading && (
                <div className="space-y-6">
                    {events.map((event) => (
                        <EventFeedCard
                            key={event._id}
                            event={event}
                            currentUserId={user?._id}
                            onEventClick={handleEventClick}
                        />
                    ))}

                    {/* Empty State */}
                    {events.length === 0 && !error && (
                        <div className="text-center py-12">
                            <div className="w-16 h-16 mx-auto mb-4 bg-white/10 rounded-full flex items-center justify-center">
                                <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold text-gray-300 mb-2">No friends events yet</h3>
                            <p className="text-gray-400 mb-4">Add friends to see their events in your feed!</p>
                            <GradientButton
                                onClick={() => navigate('/add-friend')}
                                className="py-3 px-6"
                            >
                                Find Friends
                            </GradientButton>
                        </div>
                    )}
                </div>
            )}

            {/* Back Button */}
            <div className="mt-8 flex justify-center">
                <button
                    onClick={() => navigate('/home')}
                    className="bg-gray-600/20 hover:bg-gray-600/30 text-gray-300 font-medium py-3 px-8 rounded-xl border border-gray-500/30 hover:border-gray-500/50 transition-all duration-300"
                >
                    Back to Home
                </button>
            </div>
        </div>
    )
}

export default FriendsEventFeed